import {ViewSlotCreator} from "../../typings";

export const defineViewSlotCreator = function (slot: ViewSlotCreator): () => ViewSlotCreator {
    return function () {
        return slot;
    }
};
